import React, {useState} from 'react'
import {FiFolder, FiMoreVertical, FiTrash2} from 'react-icons/fi'
import {VmoDropdown, VmoDropdownItem, VmoDropdownMenu, VmoMenuItem} from 'vmo-library'
import {useForm} from 'react-hook-form'
import {joiResolver} from '@hookform/resolvers/joi'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {addSegment, deleteSegment, getAllSegment, getSegment} from 'actions/segment'
import {
  ADD_SEGMENT,
  CLEAR_SEGMENT_DATA,
  DELETE_SEGMENT,
  GET_ALL_SEGMENT,
  GET_SEGMENT,
  UPDATE_SEGMENT,
} from 'actions/types'
import useApiResponse from 'hooks/impure/useApiResponse'
import {getContactList} from 'actions/contacts'
import DeleteModal from 'components/common/DeleteModal'
import {contactSegmentStep1Schema, contactSegmentStep2Schema} from 'validation/customers/contact.schema'
import {isActiveNavlink} from 'utils/helper'
import {useDisclosure} from 'hooks/pure/useDisclosure'
import {FaEdit} from 'react-icons/fa'
import SegmentStep1 from './SegmentStep1'
import SegmentStep2 from './Contacts/SegmentStep2'

const defaultValues = {
  name: '',
  isStatic: true,
}
const defaultValues1 = {
  ids: [],
  conditions: {},
}

const AddContactSegment = ({type = 'customers', currentStep, setCurrentStep}) => {
  const {isOpen, setCustom} = useDisclosure()
  const [editId, setEditId] = useState('')
  const [filter, setFilter] = useState({})
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const {
    handleSubmit,
    formState: {errors},
    control,
    getValues,
    reset,
    watch,
  } = useForm({
    resolver: joiResolver(contactSegmentStep1Schema),
    shouldUnregister: false,
    defaultValues,
  })

  const {
    handleSubmit: handleSubmit2,
    formState: {errors: errors2},
    control: control2,
    getValues: getValues2,
    reset: reset2,
    watch: watch2,
    setValue: setValue2,
  } = useForm({
    resolver: joiResolver(contactSegmentStep2Schema),
    shouldUnregister: false,
    defaultValues: defaultValues1,
  })

  const {data: segmentList = [], callAction: callAllSegment} = useApiResponse({
    label: GET_ALL_SEGMENT,
    storePath: 'segment.segmentList',
    enabled: true,
    action: getAllSegment,
    onSuccess: () => {
      dispatch({type: CLEAR_SEGMENT_DATA})
      reset(defaultValues)
      reset2(defaultValues1)
      setEditId('')
      setCurrentStep(null)
    },
  })

  const {callAction: callActionAddSegment} = useApiResponse({
    label: ADD_SEGMENT,
    action: addSegment,
    onSuccess: () => {
      callAllSegment()
    },
  })
  const {callAction: callActionUpdateSegment} = useApiResponse({
    label: UPDATE_SEGMENT,
    onSuccess: () => {
      callAllSegment()
    },
  })
  const {callAction: callActionDelete} = useApiResponse({
    label: DELETE_SEGMENT,
    action: deleteSegment,
    onSuccess: () => {
      callAllSegment()
    },
  })

  const {callAction: callActionGetSegment} = useApiResponse({
    label: GET_SEGMENT,
    storePath: 'segment.segmentData',
    action: getSegment,
    onSuccess: segmentData => {
      reset({name: segmentData.name, isStatic: segmentData.isStatic})
      reset2({
        conditions: segmentData.conditions,
        ids: segmentData.ids,
      })
      setFilter(segmentData.conditions)
    },
  })

  const CreateSegment = () => {
    const payload = {
      ...getValues(),
      ...getValues2(),
    }

    if (editId) {
      callActionUpdateSegment({type, data: payload, id: editId})
    } else {
      callActionAddSegment({type, data: payload})
    }
  }
  return (
    <>
      {segmentList.map((segment, index) => (
        <VmoMenuItem
          className="vmo-seg-item"
          key={index}
          active={isActiveNavlink(`/${type}/segment/${segment.id}`)}
          onClick={() => {
            navigate(`/${type}/segment/${segment.id}`)
            dispatch(getContactList({segmentId: segment.id}))
          }}
        >
          <FiFolder /> {segment.name}
          <VmoDropdown button icon={<FiMoreVertical />} className="right-dd">
            <VmoDropdownMenu className="m-0" direction="left">
              <VmoDropdownItem
                onClick={() => {
                  setCurrentStep('step1')
                  setEditId(segment.id)
                  callActionGetSegment({type, id: segment.id})
                }}
                className="d-flex"
              >
                <FaEdit /> <span className="mt-2">Edit</span>
              </VmoDropdownItem>
              <VmoDropdownItem
                onClick={() => {
                  setCustom(segment.id)
                }}
              >
                <FiTrash2 /> <span className="mt-2">Delete</span>
              </VmoDropdownItem>
            </VmoDropdownMenu>
          </VmoDropdown>
        </VmoMenuItem>
      ))}

      <SegmentStep1
        open={currentStep === 'step1'}
        setOpen={setCurrentStep}
        control={control}
        handleSubmit={handleSubmit}
        errors={errors}
        watch={watch}
        type={type}
      />
      <SegmentStep2
        open={currentStep === 'customers'}
        setOpen={setCurrentStep}
        control={control2}
        handleSubmit={handleSubmit2}
        errors={errors2}
        CreateSegment={CreateSegment}
        getValues={getValues2}
        watch={watch2}
        step1Values={watch}
        setValue={setValue2}
        reset={reset2}
        filter={filter}
        setFilter={setFilter}
        editId={editId}
        type={type}
      />
      {isOpen && (
        <DeleteModal
          isModalOpen={isOpen}
          setIsModalOpen={setCustom}
          onDelete={() => {
            callActionDelete({type, id: isOpen})
          }}
          type={type}
        />
      )}
    </>
  )
}

export default AddContactSegment
